import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './contexts/AuthContext';
import { AdminSettingsProvider } from './contexts/AdminSettingsContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Home from './pages/Home';
import LandingPage from './pages/LandingPage';
import Financial from './pages/Financial';
import Members from './pages/Members';
import EmailVerification from './components/EmailVerification';

import Administration from './pages/Administration';
import MissionsAdmin from './pages/MissionsAdmin';
import Profile from './pages/Profile';
import NavigationDemo from './pages/NavigationDemo';
import TestModal from './pages/TestModal';
import ModalTest from './pages/ModalTest';
import DocView from './pages/DocView';
import Signature from './pages/Signature';
import AdminVolunteers from './pages/AdminVolunteers';
import Acolhimento from './pages/Acolhimento';
import Celulas from './pages/Celulas';
import CheckIn from './pages/CheckIn';
// Removido: import WhatsAppSetup from './components/WhatsAppSetup';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <AdminSettingsProvider>
        <Router
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true,
        }}
      >
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={
              <div className="min-h-screen flex items-center justify-center bg-background-color py-6 sm:py-12 px-4 sm:px-6 lg:px-8">
                <EmailVerification />
              </div>
            } />
            <Route path="/" element={<LandingPage />} />
            <Route path="/home" element={
              <ProtectedRoute>
                <Layout>
                  <Home />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/financeiro" element={
              <ProtectedRoute allowedRoles={['tesoureiro', 'pastor', 'administracao']}>
                <Layout>
                  <Financial />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/secretaria" element={
              <ProtectedRoute allowedRoles={['secretario', 'pastor', 'administracao']}>
                <Layout>
                  <Members />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/celulas" element={
              <ProtectedRoute>
                <Layout>
                  <Celulas />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/checkin" element={
              <ProtectedRoute allowedRoles={['secretario', 'pastor', 'administracao']}>
                <Layout>
                  <CheckIn />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/acolhimento" element={
              <ProtectedRoute allowedRoles={['pastor', 'administracao']}>
                <Layout>
                  <Acolhimento />
                </Layout>
              </ProtectedRoute>
            } />

            <Route path="/administracao" element={
              <ProtectedRoute allowedRoles={['administracao']}>
                <Layout>
                  <Administration />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/administracao/missoes" element={
              <ProtectedRoute allowedRoles={['administracao', 'pastor']}>
                <Layout>
                  <MissionsAdmin />
                </Layout>
              </ProtectedRoute>
            } />
            {/* Removida rota /whatsapp */}
            <Route path="/perfil" element={
              <ProtectedRoute>
                <Layout>
                  <Profile />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/navigation-demo" element={<NavigationDemo />} />
            <Route path="/test-modal" element={<TestModal />} />
            <Route path="/modal-test" element={<ModalTest />} />
            <Route path="/docs/view" element={
              <ProtectedRoute>
                <Layout>
                  <DocView />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/assinaturas" element={
              <ProtectedRoute allowedRoles={['administracao','secretario','pastor']}>
                <Layout>
                  <Signature />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/administracao/voluntariado" element={
              <ProtectedRoute allowedRoles={['administracao']}>
                <Layout>
                  <AdminVolunteers />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            style={{ zIndex: 1000000 }}
          />
        </div>
      </Router>
      </AdminSettingsProvider>
    </AuthProvider>
  );
}

export default App;
